import React, { Component } from "react";
import VoteButton from "./VoteButton";

class Item extends Component {
  state = {
    active: false,
  };

  handleClick = this.handleClick.bind(this);

  handleClick() {
      if(!this.state.active && this.props.voteCount < this.props.votesLimit) {
        this.props.addVote(this.props.item.idreg)
        this.setState({
          active: !this.state.active,
        });
      }
      if(this.state.active) {
        this.props.removeVote(this.props.item.idreg)
        this.setState({
          active: !this.state.active,
        });
      }
      
      
  }
  render() {
    const item = this.props.item;
    return (
      <div className="card mb-4">
        <div className="card-body">
          <div className="card-pelicula">
            <h5 className="card-title">{item.titulo}</h5>
            <h6 className="card-subtitle mb-2 text-muted">{item.realizador}</h6>
            <h6 className="card-subtitle mb-2 text-muted">{item.duracion}</h6>
          </div>
          <VoteButton
            className={this.state.active ? "btn btn-lg btn-success btn-block" : "btn btn-lg btn-primary btn-block"}
            toggleClassName={this.handleClick}
            active={this.state.active}>
              { this.state.active ? "Quitar voto " : "Votar " }
          </VoteButton>
        </div>
      </div>
    );
  }
}

export default Item;
